import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RegistrationApprovalsPopUpComponent from '@/routers/views/approval-request/registration-approval-popup/registration-approval-popup';
import { approvalRequestsAPI } from '@/providers/apis/approval-requests/approval-requests';
@Component({
    name: 'approval-request',
    components: {
        RegistrationApprovalsPopUpComponent,
    },
})

export default class RegistrationApprovalsComponent extends Vue {

    // Properties
    private editUserDetails = false;
    private getApprovedData = false;
    private getRejectedData = false;

    private registrationApprovalsListData: any = [];
    private getIndexItemapprovals: any = [];
    private isLoading = false;
    private userListSerach = '';
    private offset: number = 0;
    private limit: number = 10;
    private perPage: number = 10;
    private totalRowCounts: number = 10;
    private currentPage: number = 1;
    private registrationApprovalsHeader: any = [
        {
            label: '',
            key: 'index',
            sortable: false,
            tdClass: 'vertically-center body-checkbox',
            thClass: 'header-checkbox',

        },
        {
            label: 'Date',
            key: 'createdAt',
            sortable: false,
            tdClass: 'vertically-center body-date td-style',
            thClass: 'header-date',
        },
        {
            label: 'First Name',
            key: 'first_name',
            sortable: false,
            tdClass: 'vertically-center td-style body-first-name',
            thClass: 'header-first-name',
        },
        {
            label: 'Last Name',
            key: 'last_name',
            sortable: false,
            tdClass: 'vertically-center td-style body-last-name',
            thClass: 'header-last-name ',
        },

        {
            label: 'Email Address',
            key: 'email',
            sortable: false,
            tdClass: 'vertically-center td-style  body-email',
            thClass: 'header-email',
        },
        {
            label: 'Grade',
            key: 'info',
            sortable: false,
            tdClass: 'vertically-center  td-style body-grade',
            thClass: 'header-grade',
        },
        {
            label: 'School ',
            key: 'schools',
            sortable: false,
            tdClass: 'vertically-center body-school',
            thClass: 'header-school',
        },
        {
            label: 'Town ',
            key: 'town',
            sortable: false,
            tdClass: 'vertically-center  td-style body-town',
            thClass: 'header-town',
        },
        {
            label: 'Status ',
            key: 'Status',
            sortable: false,
            tdClass: 'vertically-center td-style body-status',
            thClass: 'header-status',
        },
        {
            label: '',
            key: 'editIcon',
            sortable: false,
            tdClass: 'vertically-center body-action action-col td-style body-action',
            thClass: 'header-action',
        },
    ];

    private accountVerifiedPopUp = false;
    private dropDownLeave = false;

    private headerCheckBox = false;
    private isSelectAll: boolean = false;
    private selected = [];

    private userListGradeSerach = '';

    private getSelectedRowId: any = [];
    private selectedRows: any = [];

    private userListSchoolSerach = '';
    private userListTownSerach = '';
    private userListDateSerach = '';
    private getStatusName = '';

    private selectAll = false;
    private rejectedReason = false;


    public updateSelected(item: any) {

        if (item.selected) {
            if (!this.selectedRows.includes(item)) {
                this.selectedRows.push(item);
            }
        } else {
            this.selectedRows = this.selectedRows.filter((row: any) => row !== item);
        }
        this.selectAll = this.selectedRows.length === this.registrationApprovalsListData.length;
    }

    public toggleSelectAll(data: any) {
        if (data === 'custamaizeCheckBox') {
            this.selectAll = !this.selectAll;
        }
        if (this.selectAll) {
            this.registrationApprovalsListData.forEach((item: any) => {
                if (item.status === 'pending') {
                    item.selected = true;
                    if (!this.selectedRows.includes(item)) {
                        this.selectedRows.push(item);
                    }
                }

            });
        } else {
            this.registrationApprovalsListData.forEach((item: any) => (item.selected = false));
            this.selectedRows = [];
        }
    }
    public statusDropdown() {
        this.dropDownLeave = true;
        this.getSelectedRowId = [];

        this.selectedRows.forEach((item: any, index: any) => {
            if (item.status === 'pending') {

                this.getSelectedRowId.push({ id: item.id, status: 'approved', comment: 'comments' });

            }
        });
    }

    public dropdownItemSelectHeader(data: any) {
        if (data === 'Approved') {
            this.getStatusName = 'verified';
        } else {
            this.getStatusName = 'notVerified';
        }
        this.offset = 0;
        this.RegistrationApprovalsList();
    }
    public userSearchListData() {
        if (this.userListSerach.length > 2 || this.userListGradeSerach.length > 1
            || this.userListSchoolSerach.length > 1 || this.userListDateSerach.length > 2
            || this.userListTownSerach.length > 2) {
            this.offset = 0;
            this.RegistrationApprovalsList();
        }

    }

    public resetRegistrationApprovals() {
        this.offset = 0;
        this.currentPage = 1;
        this.userListGradeSerach = '';
        this.userListSerach = '';
        this.userListSchoolSerach = '';
        this.userListTownSerach = '';
        this.userListDateSerach = '';
        this.getStatusName = '';
        this.RegistrationApprovalsList();
    }

    public userSearchAccessListClear(data: any) {
        this.offset = 0;
        if (data === 'userListSearch') {
            this.userListSerach = '';
        } else if (data === 'userListGradeSerach') {
            this.userListGradeSerach = '';
        } else if (data === 'userListDateSerach') {
            this.userListDateSerach = '';
        } else if (data === 'userListTownSerach') {
            this.userListTownSerach = '';
        } else {
            this.userListSchoolSerach = '';
        }
        this.RegistrationApprovalsList();
    }

    public RegistrationApprovalsList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const search = this.userListSerach;
        const grade = this.userListGradeSerach;
        const school = this.userListSchoolSerach;
        const searchByDate = this.userListDateSerach;
        const status = this.getStatusName;
        const town = this.userListTownSerach;
        const params: any = {
            offset,
            limit,
            search,
            grade,
            school,
            searchByDate,
            status,
            town,
        };
        approvalRequestsAPI.getUserList(params).then((response: any) => {
            this.isLoading = false;
            this.selectedRows = [];
            this.selectAll = false;
            this.headerCheckBox = false;
            response.data.users.forEach((item: any) => {
                if (item.status === 'pending') {
                    this.headerCheckBox = true;
                }
            });
            this.registrationApprovalsListData = response.data.users;

            this.totalRowCounts = response.data.totalCount;
        });

    }

    public onSelectPage(pageNumber: number) {
        this.currentPage = pageNumber;
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.RegistrationApprovalsList();
    }
    public editStudentDetails(data: any, getIndexItem: any) {
        this.getIndexItemapprovals = getIndexItem;
        if (data === 'editUserdetailes' && (getIndexItem.item.status === 'pending'
        )) {
            this.editUserDetails = true;
            this.getApprovedData = false;
            this.getRejectedData = false;
            setTimeout(() => {
                this.$bvModal.show('edit-user-detailes-popup');
            }, 500);
        }
    }

    public updateUserApproved(listIndex: any) {
        const params: any = {
            users:
                listIndex,
        };
        approvalRequestsAPI.updateUserStaus(params).then((response: any) => {
            if (response.status === 200) {
                this.$bvModal.show('account-verified-popup');
                setTimeout(() => {
                    this.isLoading = false;
                    this.RegistrationApprovalsList();
                    this.selectedRows = [];
                }, 1000);
            }
        });
    }

    public multipleOptionDropdownItem(data: any) {
        this.rejectedReason = false;
        if (this.getSelectedRowId.length >= 1) {
            if (data === 'approved') {
                this.isLoading = true;
                this.dropDownLeave = false;
                this.getApprovedData = true;
                this.editUserDetails = false;
                this.getRejectedData = false;
                const listIndex = this.getSelectedRowId;
                this.updateUserApproved(listIndex);
            }
        }

    }
    public rejectedReasoncomments(getIndexItem: any) {
        this.getIndexItemapprovals = getIndexItem;
        this.rejectedReason = true;
        setTimeout(() => {
            this.$bvModal.show('rejected-reason-popup');

        }, 500);

    }

    public popUpHide() {
        this.editUserDetails = false;
        this.getRejectedData = false;
        this.getApprovedData = false;
        this.rejectedReason = false;
    }
    public dropdownItem(data: any, getIndexItem: any) {
        this.rejectedReason = false;
        if (data === 'Approved') {
            this.getIndexItemapprovals = getIndexItem;
            this.selectedRows = [];
            this.isLoading = true;
            this.getApprovedData = true;
            this.editUserDetails = false;
            this.getRejectedData = false;
            const id = getIndexItem.item.id;
            const listIndex: any = [{
                id,
                status: 'approved',
                comment: 'comments',
            }];
            this.updateUserApproved(listIndex);
        }
        if (data === 'Rejected') {
            this.getIndexItemapprovals = getIndexItem;
            this.getRejectedData = true;
            this.getApprovedData = false;
            this.editUserDetails = false;
            setTimeout(() => {
                this.$bvModal.show('activation-rejected-popup');

            }, 500);
        }
    }

    private created() {
        this.RegistrationApprovalsList();
    }
}


